<template>
  <md-card
    class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30"
    style="
      color: #8cc63f;
      min-height: 200px;
      border: solid;
      border-radius: 30px;
      border-width: 2px;
    "
  >
    <div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding: 10px;
          flex-direction: column;
          align-items: center;
        "
      >
        <div
          style="
            height: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 20px;
          "
        >
          <img
            v-if="item.media_id"
            style="
              object-fit: contain;
              display: block;
              max-height: 100%;
              max-width: 100%;
            "
            :src="
              'data:image/' +
              item.plan_image.extension +
              ';base64,' +
              item.plan_image.image
            "
            alt=""
          />
        </div>
        <h4 style="margin-top: 5px; color: #375355">
          {{ item.name }}
        </h4>
        <div class="col-12 planDivAttributes" style="margin-top: 30px">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Plan Code</label
          >
          <label style="line-height: normal" class="planAttributes col-7">
            {{ item.code }}
          </label>
        </div>
        <div class="col-12 planDivAttributes">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Description</label
          >
          <label style="line-height: normal" class="planAttributes col-7">
            {{ item.description }}
          </label>
        </div>
        <div class="col-12 planDivAttributes">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Min Principal</label
          >
          <label class="planAttributes col-7">
            {{ item.min_principal.toLocaleString() }} {{ item.currency_code }}
          </label>
        </div>
        <div class="col-12 planDivAttributes">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Max Principal</label
          >
          <label class="planAttributes col-7">
            {{ item.max_principal.toLocaleString() }} {{ item.currency_code }}
          </label>
        </div>
        <div class="col-12 planDivAttributes">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Min Period</label
          >
          <label class="planAttributes col-7">
            {{ item.min_period }}
            {{ item.period.charAt(0).toUpperCase() + item.period.slice(1) }}
          </label>
        </div>
        <div class="col-12 planDivAttributes">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Withdrawal</label
          >
          <label class="planAttributes col-7">
            {{ item.withdrawal_notice }}
            {{
              item.withdrawal_notice_period.charAt(0).toUpperCase() +
              item.withdrawal_notice_period.slice(1)
            }}
            Notice
          </label>
        </div>
        <div class="col-12 planDivAttributes">
          <label
            class="col-5"
            style="
              color: #8cc63f;
              padding: 0;
              font-size: 13px;
              font-weight: bold;
            "
            >Estimated ROI</label
          >
          <label class="planAttributes col-7"> {{ item.est_roi }}% </label>
        </div>
        <div
          class="col-12"
          style="text-align: center; margin: 20px; padding: 10px"
        >
          <button
            style="border-radius: 5px; background-color: #8cc63f; color: white"
            type="button"
            class="btn"
            @click="(event) => emitViewPlan(event, item)"
          >
            View Plan
          </button>
        </div>

        <!-- <div
            style="
              display: flex;
              justify-content: end;
              margin: 8px;
              padding: 10px;
            "
            class="col-12"
          >
            <button
              style="
                border-radius: 30px;
                padding-top: 0px;
                padding-left: 7px;
                padding-right: 7px;
                padding-bottom: 0px;
                margin-right: 10px;
              "
              type="button"
              class="btn btn-warning"
              @click="(event) => emitUpdate(event, item)"
            >
              <i
                style="font-size: 12px; color: white"
                class="fa fa-arrow-up"
              ></i>
            </button>
            <button
              style="
                border-radius: 30px;
                padding-top: 0px;
                padding-left: 7px;
                padding-right: 7px;
                padding-bottom: 0px;
              "
              @click="(event) => emitDelete(event, item)"
              type="button"
              class="btn btn-danger"
            >
              <i style="font-size: 12px" class="fa fa-trash"></i>
            </button>
          </div> -->
      </div>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "plan",
  props: ["item"],
  data() {
    return {
      showProjects: false,
    };
  },
  components: {},
  methods: {
    emitUpdate(event, plan) {
      this.$emit("event", { name: "updatePlan", payload: plan });
      event.preventDefault();
    },
    emitDelete(event, plan) {
      this.$emit("event", { name: "deletePlan", payload: plan.id });
      event.preventDefault();
    },
    emitViewPlan(event, plan) {
      this.$emit("event", { name: "viewPlan", payload: plan });
      event.preventDefault();
    },
  },
};
</script>
<style scoped>
.planAttributes {
  color: rgb(55, 83, 85);
  padding: 0;
  padding-left: 5px !important;
  font-size: 13px;
}
.planDivAttributes {
  padding: 0;
  display: flex;
  align-items: start;
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/Layouts/Items/plan.vue